import { EImagingScheduleAction, ImagingScheduleAction } from "../actions/ImagingScheduleActions";
import { FetchStatus } from "../../Model/FetchStatus";
import { ScheduleEntry } from "../../Model/ImagingSchedule";
import { RootState } from "./RootReducer";

interface State {
  status: FetchStatus;
  queuedPlates: ScheduleEntry[];
  scheduledPlates: ScheduleEntry[];
}

const initialState: State = {
  queuedPlates: [],
  scheduledPlates: [],
  status: {
    pending: false,
    completed: false,
    error: null,
  },
};

export function imagingScheduleReducer(state = initialState, action: ImagingScheduleAction): State {
  switch (action.type) {
    case EImagingScheduleAction.FETCH_IMAGING_SCHEDULE_PENDING:
      return {
        ...state,
        status: {
          pending: true,
          completed: false,
          error: null,
        },
      };
    case EImagingScheduleAction.FETCH_IMAGING_SCHEDULE_SUCCESS:
      if (action.queuedPlates == null) {
        throw new Error("Queued plates is null");
      }
      if (action.scheduledPlates == null) {
        throw new Error("Scheduled plates is null");
      }
      return {
        ...state,
        queuedPlates: action.queuedPlates,
        scheduledPlates: action.scheduledPlates,
        status: {
          pending: false,
          completed: true,
          error: null,
        },
      };
    case EImagingScheduleAction.SCHEDULED_PLATES_UPDATED:
      if (action.scheduledPlates == null) {
        throw new Error("Scheduled plates is null");
      }
      return {
        ...state,
        scheduledPlates: action.scheduledPlates,
      };
    case EImagingScheduleAction.QUEUED_PLATES_UPDATED:
      if (action.queuedPlates == null) {
        throw new Error("Queued plates is null");
      }
      return {
        ...state,
        queuedPlates: action.queuedPlates,
      };
    case EImagingScheduleAction.FETCH_IMAGING_SCHEDULE_ERROR:
      return {
        ...state,
        status: {
          pending: false,
          completed: true,
          error: action.error,
        },
      };
    default:
      return state;
  }
}

export const getQueuedPlates = (state: RootState) => state.imagingScheduleStore.queuedPlates;
export const getScheduledPlates = (state: RootState) => state.imagingScheduleStore.scheduledPlates;
export const getImagingScheduleFetchStatus = (state: RootState) => state.imagingScheduleStore.status;
